import { AdditionalFeatures } from './types.ts';

export function extractAdditionalFeatureMetadata(subjectSale: Element): AdditionalFeatures {
  const adjustmentSrc = Array.from(
    subjectSale.getElementsByTagName('SALE_PRICE_ADJUSTMENT'),
  ).filter((element) => element.getAttribute('_Type') === 'Other');

  return {
    feature1: {
      label: adjustmentSrc[0]?.getAttribute('_TypeOtherDescription') ?? '',
      value: adjustmentSrc[0]?.getAttribute('_Description') ?? '',
    },
    feature2: {
      label: adjustmentSrc[1]?.getAttribute('_TypeOtherDescription') ?? '',
      value: adjustmentSrc[1]?.getAttribute('_Description') ?? '',
    },
    feature3: {
      label: adjustmentSrc[2]?.getAttribute('_TypeOtherDescription') ?? '',
      value: adjustmentSrc[2]?.getAttribute('_Description') ?? '',
    },
  };
}
